import React from 'react'

const SectionHeader = ({title , subTitle}) => {
  return (
    <div className='section_title text-center'>
        <p className='text-style  text-green my-4 '>{subTitle}</p>
        <h2 className='text-black fw-700'> {title}</h2>

    </div>
  )
}

export default SectionHeader